import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './Components/landing-page/landing.component';
import { LoginComponent } from './Components/auth/login.component';
import { AuthGuardService } from './services/auth-guard.service';
import { InstitutesComponent } from './Components/institutes/institutes.component';
import { CoursesComponent } from './Components/courses/courses.component';
import { LoanDetailsComponent } from './Components/loan-details/loan-details.component';
import { StudentDetailsComponent } from './Components/student-details/student-details.component';
import { KycComponent } from './Components/kyc/kyc.component';
import { PanDetailsComponent } from './Components/kyc/pan-details/pan-details.component';
import { EmploymentDetailsComponent } from './Components/kyc/employment-details/employment-details.component';
import { BasicDetailsComponent } from './Components/kyc/basic-details/basic-details.component';
import { BankDetailsComponent } from './Components/proof-verification/bank-details/bank-details.component';

import { RouteConstants } from 'src/assets/constants/route';
import { EmailVerificationComponent } from './Components/email-verification/email-verification.component';
import { WelcomeComponent } from './Components/welcome/welcome.component';
import { MoratoriumComponent } from './Components/moratorium/moratorium.component';
import { InsuranceComponent } from './Components/insurance/insurance.component';
import { GrievanceRedressalComponent } from './Components/grievance-redressal/grievance-redressal.component';
import { FaqComponent } from './Components/faq/faq.component';
import { ContactUsComponent } from './Components/contact-us/contact-us.component';
import { EmiCalculatorComponent } from './Components/emi-calculator/emi-calculator.component';
import { EligibilityComponent } from './Components/eligibility/eligibility.component';
import { ProcessingFeeComponent } from './Components/processing-fee/processing-fee.component';
import { NoResultsComponent } from './Components/no-results/no-results.component';
import { FooterComponent } from './shared/footer/footer.component';
import { PrivacyComponent } from './Components/privacy/privacy.component';
import { HomeComponent } from './Components/landing-page/home/home.component';
import { KycDetailsComponent } from './Components/kyc-details/kyc-details.component';
import { AfterSanctionComponent } from './Components/after-sanction/after-sanction.component';

const routes: Routes = [

  {
    path: '',
    component: LandingComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate:[AuthGuardService]
      },
      // {
      //   path: 'home-new',
      //   component: HomeComponent,
      // },
      {
        path: 'home',
        component: HomeComponent,
        canActivate:[AuthGuardService]
      },
      {
        path: 'login',
        component: LoginComponent,
        canActivate:[AuthGuardService]
      },
      {
        path: 'emailVerification',
        component: EmailVerificationComponent,
        canActivate:[AuthGuardService]
      },
      {
        path: 'footer',
        component: FooterComponent,
      },
      {
        path: 'institutes',
        component: InstitutesComponent,
        canActivate:[AuthGuardService]
      },
      {
        path: 'courses',
        component: CoursesComponent,
        canActivate:[AuthGuardService]
      },
      {
        path: 'loan-details',
        component: LoanDetailsComponent,
        canActivate:[AuthGuardService]
      },
      {
        path: 'student-details',
        component: StudentDetailsComponent,
        canActivate:[AuthGuardService]
      },

      {
        path: 'kyc-details',
        component: KycComponent,
        canActivate:[AuthGuardService],
        children: [
          {
            path: '',
            component: PanDetailsComponent,
          },
          {
            path: 'pan',
            component: PanDetailsComponent,
          },
          {
            path: 'basic-details',
            component: BasicDetailsComponent,
          },
          {
            path: 'employment-details',
            component: EmploymentDetailsComponent
          },
          {
            path: 'bank-details',
            component: BankDetailsComponent,
          },
          // {
          //   path: 'aadhar-details',
          //   component: AadharDetailsComponent,
          // },
          {
            path: 'aadhar-details',
            component: KycDetailsComponent,
          },
          {
            path: 'selfie',
            component: KycDetailsComponent
          },

        ]
      },
      // {
      //   path: 'proof-verification',
      //   component: ProofVerificationComponent,
      //   canActivate:[AuthGuardService],
      //   children: [
      //     {
      //       path: '',
      //       component: BankDetailsComponent,
      //     },
      
      //   ]
      // },
      {
        path: 'key-fact-statement',
        //component: KeyFactStatementComponent,
        component:AfterSanctionComponent,
        canActivate:[AuthGuardService],
      },
      {
        path: 'application-letter',
        // component: ApplicationLetterComponent,
        component:AfterSanctionComponent,
        canActivate:[AuthGuardService],
      },
      {
        path: 'nach-mandate',
        // component: NachMandateComponent,
        component:AfterSanctionComponent,
        canActivate:[AuthGuardService],
      },
      {
        path: 'welcome',
        component: WelcomeComponent,
        canActivate:[AuthGuardService],
      },
      {
        path: 'moratorium',
        component: MoratoriumComponent,
        canActivate:[AuthGuardService],
      },
      {
        path: 'insurance',
        component: InsuranceComponent,
        canActivate:[AuthGuardService],
      },
      {
        path: 'grievance-redressal',
        component: GrievanceRedressalComponent
      },
      {
        path: 'faq',
        component: FaqComponent
      },
      {
        path: 'contact-us',
        component: ContactUsComponent
      },
      {
        path: 'emi-calculator',
        component: EmiCalculatorComponent
      },
      {
        path: 'processing-fee',
        component: ProcessingFeeComponent
      },
      {
        path: 'privacy',
        component: PrivacyComponent,
      },
      {
        path: 'no-results',
        component: NoResultsComponent
      },

    ]
  },
  {
    path:'eligibility',
    component:EligibilityComponent,
    canActivate:[AuthGuardService]
  },
  {
    path:'**',
    redirectTo: RouteConstants.routes.main,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash:false})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
